const matchingChild = (key) => (childAppendix) => {
  return key.endsWith(childAppendix)
}

const possibleSlots = (slots, keys) => {
  return Object.keys(slots)
    .filter(key => {
      return keys.find(matchingChild(key))
    })
    .map(key => {
      const childAppendix = keys.find(matchingChild(key))
      return {
        parent: key,
        child: key.slice(0, -childAppendix.length)
      }
    })
}

export default function slotProxy (childAppendices) {
  return {
    props: {
      childAppendices: {
        type: Array
      }
    },
    computed: {
      effectiveChildAppendices () {
        if (Array.isArray(childAppendices)) {
          return childAppendices
        }
        return this.childAppendices || []
      },
      possibleChildSlots () {
        return possibleSlots(this.$slots, this.effectiveChildAppendices)
      }
    },
    methods: {
      getSlotText (name, defaultText = '') {
        if (typeof this.$slots[name] !== 'undefined' && Array.isArray(this.$slots[name]) && this.$slots[name][0] && typeof this.$slots[name][0].text !== 'undefined') {
          return this.$slots[name][0].text
        }

        return defaultText
      },
      possibleChildSlotsFor (key, dynamic = null) {
        return [
          ...possibleSlots(this.$slots, [key]),
          ...((dynamic !== null) ? possibleSlots(this.$slots, [`${key}${dynamic}`]) : [])
        ]
      }
    }
  }
}
